import httpClientNotifications from '../api/httpClientNotifications';

export const sendEmail = async (payload) => {
  const response = await httpClientNotifications.post('/api/notifications/Email/Send', payload);
  return response.data;
};

export const sendEmailWithTemplate = async (payload) => {
  const response = await httpClientNotifications.post('/api/notifications/Email/SendWithTemplate', payload);
  return response.data;
};

export const getSentEmails = async ({ pageNumber = 1, pageSize = 10, search } = {}) => {
  const response = await httpClientNotifications.get('/api/notifications/Email/GetSentEmails', {
    params: { pageNumber, pageSize, search },
  });
  return response.data;
};

export default {
  sendEmail,
  sendEmailWithTemplate,
  getSentEmails,
};


